/* eslint-disable react-hooks/exhaustive-deps */
import {
  FORMAT_LIST_TESTS,
  FIELD_ARRAY_VALUE,
  CHS_PROJECT_NAME,
} from '../../constants';
import { isHomebasedAvailable } from '../../constants';
import {
  formatCustomCategories,
  formatData,
  formatExpressTotalTestServices,
  formatMeasurementInSideListTest,
  generateLstTests,
  generateScreeningFieldsListData,
  returnOptionalPackageTests,
} from '../../utils';
import HomebasedBloodTakingModal from '../CreateAppointment/HomebasedBloodTakingModal';
import FollowSelectServices from './FollowSelectServices';
import SelectServices from './SelectServices';
import { HomebasedIcon } from '@/assets/svg';
import { urlLabel } from '@/enum/PermissionEnum';
import Invoice from '@/module/all-screenings/component/Invoice';
import checkinPatientDispatcher from '@/module/checkin-patient-information/action';
import companyDispatcher from '@/module/company/action';
import { packageDispatcher } from '@/module/package-management';
import locationDispatcher from '@/module/setup/action';
import { refactorListData as refactorListTestData } from '@/module/setup/constants';
import upcomingHSDispatcher from '@/module/upcoming-health-screening/action';
import { ClearComponent } from '@/new-components/ClearComponent';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles, makeStyles } from '@material-ui/styles';
import { cloneDeep, get, isBoolean, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  },

  rightContainer: {
    display: 'flex',
    padding: '16px 20px',
    overflowX: 'auto',
    height: 'calc(100vh - 222px)',
  },

  leftContainer: {
    flex: '1',
    borderRight: '1px solid #F1F1F1',
    height: 'calc(100vh - 222px)',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
  },
});

const CustomTextField = withStyles({
  root: {
    fontSize: 20,

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: 48,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: 0,
      paddingLeft: 5,
      fontSize: 16,
    },

    '& .MuiInputBase-inputMultiline': {
      '&.MuiInputBase-input': {
        marginLeft: 0,
      },
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
    '& .MuiInputBase-adornedStart': {
      '& .MuiTypography-root': {
        fontSize: 16,
        color: '#333333',
      },
      '& .MuiInputAdornment-positionStart': {
        marginRight: 0,
      },
      '& input': {
        marginLeft: 0,
      },
    },
  },
})(TextField);

const CustomTitleSubLabel = withStyles({
  root: {
    fontWeight: 600,
    color: '#666666',
  },
})(Typography);

const EditPackage = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const apptData = get(location, 'state', {});
  const label = get(location, 'label', '');
  const isRegisterPatient = get(apptData, 'isRegisterPatient', false);
  const isAfterRegistration = get(apptData, 'isAfterRegistration', false);
  const isFollowUp = get(apptData, 'isFollowUpAppointment', false);
  const locationId = get(apptData, 'locationId', '');
  const { paxScreeningData } = useSelector((state) => state.upcomingHS);

  const [formValue, setFormValue] = useState({});
  const [packageDetail, setPackageDetail] = useState({});
  const [restrictedTestIds, setRestrictedTestIds] = useState([]);

  // Homebased blood-taking (offered when editing an eligible EHS package)
  const [patientId, setPatientId] = useState('');
  const [openHomebasedConfirm, setOpenHomebasedConfirm] = useState(false);
  const [openHomebasedModal, setOpenHomebasedModal] = useState(false);
  const [homebasedInfo, setHomebasedInfo] = useState(null);

  const [projectCustomFields, setProjectCustomFields] = useState([]);
  const [lstOptionalTests, setLstOptionalTests] = useState([]);
  const [currentPackage, setCurrentPackage] = useState({});
  const [dataPackageExisted, setDataPackageExisted] = useState({});
  const [projectInfo, setProjectInfo] = useState({});
  const [hasEditPackage, setHasEditPackage] = useState(false);
  const [originalPrices, setOriginalPrices] = useState({
    packages: {},
    profiles: {},
    tests: {},
  });

  const [sessionBookedPrices, setSessionBookedPrices] = useState({
    packages: {},
    profiles: {},
    tests: {},
  });
  const [originalLstTestsForPreCalculate, setOriginalLstTestsForPreCalculate] =
    useState([]);

  const [loading, setLoading] = useState(false);
  const onCancel = () => {
    history.push({
      pathname: `/${urlLabel.aSRegisterPatient}`,
      state: { ...apptData, isViewRegistration: false, hasEditPackage: false },
      label,
    });
  };

  const formatParamsData = (
    data,
    projectId,
    itemType = 'test',
    originalPricesMap = {}
  ) => {
    const result = { price: data.price, id: data.id, projectId };

    // Preserve total property for grouped measurements so it can be expanded later
    if (data.total && Array.isArray(data.total) && data.total.length > 0) {
      result.total = data.total;
    }

    // Preserve isUseNewPrice if it was already set (from parent propagation) - check this FIRST
    if (data.isUseNewPrice === true) {
      result.isUseNewPrice = true;
    }

    // Check if this item was previously booked with a different price
    if (originalPricesMap && Object.keys(originalPricesMap).length > 0) {
      let originalPrice = null;
      const itemId = data.id || data.testId;

      if (itemType === 'package' && originalPricesMap.packages) {
        originalPrice = originalPricesMap.packages[itemId];
      } else if (itemType === 'profile' && originalPricesMap.profiles) {
        originalPrice = originalPricesMap.profiles[itemId];
      } else if (itemType === 'test' && originalPricesMap.tests) {
        originalPrice = originalPricesMap.tests[itemId];
      }

      // If original price exists and differs from current price, mark as using new price
      if (
        originalPrice !== null &&
        originalPrice !== undefined &&
        originalPrice !== data.price
      ) {
        result.isUseNewPrice = true;
      }

      // Handle grouped measurements (items with total property)
      // For grouped measurements, compare current price with sum of original prices from total array
      if (
        itemType === 'test' &&
        data.total &&
        Array.isArray(data.total) &&
        data.total.length > 0
      ) {
        // Calculate sum of original prices from total array
        let hasOriginalPrices = false;
        const sumOriginalPrices = data.total.reduce((sum, item) => {
          const itemOriginalPrice =
            originalPricesMap.tests?.[item.id || item.testId];
          if (itemOriginalPrice !== undefined && itemOriginalPrice !== null) {
            hasOriginalPrices = true;
            return sum + itemOriginalPrice;
          }
          return sum;
        }, 0);

        // Only compare if we have at least one original price
        // If prices differ, mark as using new price
        if (hasOriginalPrices && data.price !== sumOriginalPrices) {
          result.isUseNewPrice = true;
        }
      }
    }

    return result;
  };

  const onSubmit = (homebasedData = homebasedInfo) => {
    if (!isAfterRegistration) {
      upcomingHSDispatcher.setState('editPackageData', formValue);

      history.push({
        pathname: `/${urlLabel.aSRegisterPatient}`,
        state: {
          ...apptData,
          isViewRegistration: false,
          isEditPackage: true,
          hasEditPackage: true,
          // Carry the homebased choice to the check-in (Register) step.
          homebasedData: homebasedData || null,
        },
        label,
      });
    } else {
      const { id: paxScreeningId, lstConsentIds } = apptData;
      const {
        staffType,
        lstProfiles,
        lstPackages,
        ignoredTests,
        ignoredProfiles,
        code,
      } = formValue;

      let newListTest = refactorListTestData(formValue);

      // Format grouped measurements BEFORE expanding (to detect price changes)
      // This allows us to set isUseNewPrice on grouped measurements
      const formattedTests = newListTest.map((test) =>
        formatParamsData(test, test.projectId, 'test', originalPrices)
      );

      // Expand grouped measurements and propagate isUseNewPrice to children
      newListTest = formatExpressTotalTestServices(formattedTests);

      // Format each expanded item again to check isUseNewPrice based on their own original prices
      // This ensures that individual items in grouped measurements are checked correctly
      // and preserves isUseNewPrice that was propagated from parent
      newListTest = newListTest.map((test) =>
        formatParamsData(test, test.projectId, 'test', originalPrices)
      );

      const newScreeningFieldsList = generateScreeningFieldsListData(
        formValue.lstScreeningFields
      );
      const params = {
        lstConsentIds,
        staffType,
        lstTests: newListTest,
        lstProfiles: lstProfiles.map((test) =>
          formatParamsData(test, test.projectId, 'profile', originalPrices)
        ),
        lstPackages: lstPackages.map((test) =>
          formatParamsData(test, test.projectId, 'package', originalPrices)
        ),
        ignoredTests,
        ignoredProfiles,
        lstScreeningFields: newScreeningFieldsList,
        subsidy: apptData.subsidy,
        subsidyNote: apptData.subsidyNote,
        code,
      };
      if (homebasedData) {
        params.isHomebased = true;
        params.homebasedAddressId = homebasedData.addressId;
        params.homebasedLocationId = homebasedData.locationId;
        params.date = moment(homebasedData.date).format('YYYY-MM-DD');
        params.timeSlotId = homebasedData.timeSlotId;
      } else {
        // Re-selected a normal package: clear any previous homebased state.
        params.isHomebased = false;
        params.homebasedAddressId = null;
        params.homebasedLocationId = null;
      }
      checkinPatientDispatcher.updateAfterRegistration(
        paxScreeningId,
        params,
        (isSuccess) => {
          setLoading(false);
          if (isSuccess) {
            upcomingHSDispatcher.setState('editPackageData', formValue);
            history.push({
              pathname: `/${urlLabel.aSRegisterPatient}`,
              state: {
                ...apptData,
                isViewRegistration: false,
                isEditPackage: true,
                hasEditPackage: true,
              },
              label,
            });
          }
        }
      );
    }
  };

  const handleChangeData = (data, filterKey) => {
    setHasEditPackage(true);

    let allTest = [];
    data.forEach((prj) => {
      allTest = allTest.concat(prj.items);
    });
    const selectedData = allTest.filter((test) => test.isChecked);

    if (filterKey === 'lstPackages' && isEmpty(selectedData)) {
      setFormValue({
        ...formValue,
        [filterKey]: selectedData,
        ignoredProfiles: [],
        ignoredTests: [],
      });
    } else setFormValue({ ...formValue, [filterKey]: selectedData });
  };

  const refactorListData = (data) => {
    let newLstTests = [];
    for (const [key, value] of Object.entries(data)) {
      if (FORMAT_LIST_TESTS[key] && !isEmpty(value))
        newLstTests.push({
          category: FORMAT_LIST_TESTS[key],
          items: value,
        });
    }

    return {
      staffType: formValue.staffType,
      lstPackages: formValue.lstPackages,
      lstProfiles: formValue.lstProfiles,
      lstTests: newLstTests,
    };
  };

  useEffect(() => {
    if (apptData.id && apptData.projectId) {
      setLoading(true);
      checkinPatientDispatcher.getData(apptData.id, (paxData) => {
        const {
          lstPackages,
          lstTests,
          lstProfiles,
          ignoredTests,
          ignoredProfiles,
          lstScreeningFields,
          doneFollowUpTests,
          staffType,
          parentPaxScreeningId,
          paxInfo,
        } = paxData;

        setPatientId(paxInfo?.id || '');

        // If followup, get original lstTests from parent appointment for pre-calculate
        if (isFollowUp && parentPaxScreeningId) {
          checkinPatientDispatcher.getData(
            parentPaxScreeningId,
            (parentPaxData) => {
              // Store original lstTests (without filtering) from parent for pre-calculate API
              setOriginalLstTestsForPreCalculate(parentPaxData.lstTests || []);
            }
          );
        }
        const filterScreeningField = formatCustomCategories(
          lstScreeningFields,
          FIELD_ARRAY_VALUE
        );

        let newLstPackages = !isAfterRegistration
          ? apptData?.lstPackages
          : lstPackages;

        let newIgnoredTests = !isAfterRegistration
          ? apptData?.ignoredTests
          : ignoredTests;

        let newIgnoredProfiles = !isAfterRegistration
          ? apptData?.ignoredProfiles
          : ignoredProfiles;

        // Extract original prices from initial booking data
        // Priority: 1. localStorage (persistent storage),
        //           2. paxScreeningData.originalPrices (from Redux - stored on first load),
        //           3. paxScreeningData (from Redux - initial booking data),
        //           4. paxData from API (current DB state - only if item exists)
        let original = {
          packages: {},
          profiles: {},
          tests: {},
        };

        // First, try to get from localStorage (most persistent)
        if (apptData.id) {
          try {
            const stored = localStorage.getItem(
              `originalPrices_${apptData.id}`
            );
            if (stored) {
              const parsed = JSON.parse(stored);
              if (parsed && typeof parsed === 'object') {
                original = parsed;
              }
            }
          } catch (e) {
            console.error('Failed to read originalPrices from localStorage', e);
          }
        }

        // If not found in localStorage, try Redux
        if (
          Object.keys(original.packages).length === 0 &&
          Object.keys(original.profiles).length === 0 &&
          Object.keys(original.tests).length === 0
        ) {
          if (paxScreeningData?.originalPrices) {
            original = paxScreeningData.originalPrices;
          } else {
            // Try to get from paxScreeningData (initial booking data from Redux)
            // If not available, use paxData from API (which contains current state in DB)
            const sourceData = paxScreeningData || paxData;

            if (sourceData) {
              // Extract from lstPackages
              const sourcePackages = sourceData.lstPackages || [];
              if (Array.isArray(sourcePackages)) {
                sourcePackages.forEach((pkg) => {
                  if (pkg.id && pkg.price !== undefined && pkg.price !== null) {
                    original.packages[pkg.id] = pkg.price;
                  }
                });
              }

              // Extract from lstProfiles
              const sourceProfiles = sourceData.lstProfiles || [];
              if (Array.isArray(sourceProfiles)) {
                sourceProfiles.forEach((profile) => {
                  if (
                    profile.id &&
                    profile.price !== undefined &&
                    profile.price !== null
                  ) {
                    original.profiles[profile.id] = profile.price;
                  }
                });
              }

              // Extract from lstTests - handle both structured and flat formats
              const sourceTests = sourceData.lstTests || [];
              if (Array.isArray(sourceTests)) {
                sourceTests.forEach((testItem) => {
                  // Handle structured format (category with items)
                  if (testItem.items && Array.isArray(testItem.items)) {
                    testItem.items.forEach((test) => {
                      if (
                        test.id &&
                        test.price !== undefined &&
                        test.price !== null
                      ) {
                        original.tests[test.id] = test.price;
                      }
                      // Extract prices from total array for grouped measurements
                      if (
                        test.total &&
                        Array.isArray(test.total) &&
                        test.total.length > 0
                      ) {
                        test.total.forEach((childItem) => {
                          const childId = childItem.id || childItem.testId;
                          const childPrice =
                            childItem.price !== undefined
                              ? childItem.price
                              : childItem.testPrice || 0;
                          if (
                            childId &&
                            childPrice !== undefined &&
                            childPrice !== null
                          ) {
                            original.tests[childId] = childPrice;
                          }
                        });
                      }
                    });
                  }
                  // Handle flat test structure
                  else if (
                    testItem.id &&
                    testItem.price !== undefined &&
                    testItem.price !== null
                  ) {
                    original.tests[testItem.id] = testItem.price;
                    // Extract prices from total array for grouped measurements (flat structure)
                    if (
                      testItem.total &&
                      Array.isArray(testItem.total) &&
                      testItem.total.length > 0
                    ) {
                      testItem.total.forEach((childItem) => {
                        const childId = childItem.id || childItem.testId;
                        const childPrice =
                          childItem.price !== undefined
                            ? childItem.price
                            : childItem.testPrice || 0;
                        if (
                          childId &&
                          childPrice !== undefined &&
                          childPrice !== null
                        ) {
                          original.tests[childId] = childPrice;
                        }
                      });
                    }
                  }
                });
              }
            }
          }
        }

        setOriginalPrices(original);

        // Create sessionBookedPrices snapshot from initial data (paxData/apptData)
        // This snapshot preserves prices at the start of the edit session
        // and will be used to override prices in UI until Save changes is clicked
        const sessionPrices = {
          packages: {},
          profiles: {},
          tests: {},
        };

        // Extract from packages
        const sourcePackages = !isAfterRegistration
          ? apptData?.lstPackages || []
          : lstPackages || [];
        if (Array.isArray(sourcePackages)) {
          sourcePackages.forEach((pkg) => {
            if (pkg.id && pkg.price !== undefined && pkg.price !== null) {
              sessionPrices.packages[pkg.id] = pkg.price;
            }
          });
        }

        // Extract from profiles
        const sourceProfiles = !isAfterRegistration
          ? apptData?.lstProfiles || []
          : lstProfiles || [];
        if (Array.isArray(sourceProfiles)) {
          sourceProfiles.forEach((profile) => {
            if (
              profile.id &&
              profile.price !== undefined &&
              profile.price !== null
            ) {
              sessionPrices.profiles[profile.id] = profile.price;
            }
          });
        }

        // Extract from tests (all categories: Measurements, Procedures, Radiologies, Vaccinations, Reviews)
        const sourceTests = !isAfterRegistration
          ? apptData?.lstTests || []
          : lstTests || [];
        if (Array.isArray(sourceTests)) {
          sourceTests.forEach((testItem) => {
            // Handle structured format (category with items)
            if (testItem.items && Array.isArray(testItem.items)) {
              testItem.items.forEach((test) => {
                if (
                  test.id &&
                  test.price !== undefined &&
                  test.price !== null
                ) {
                  sessionPrices.tests[test.id] = test.price;
                }

                // For grouped measurements, also extract prices from total array
                if (
                  test.total &&
                  Array.isArray(test.total) &&
                  test.total.length > 0
                ) {
                  test.total.forEach((childItem) => {
                    const childId = childItem.id || childItem.testId;
                    const childPrice =
                      childItem.price !== undefined
                        ? childItem.price
                        : childItem.testPrice || 0;
                    if (
                      childId &&
                      childPrice !== undefined &&
                      childPrice !== null
                    ) {
                      sessionPrices.tests[childId] = childPrice;
                    }
                  });
                }
              });
            }
            // Handle flat test structure
            else if (
              testItem.id &&
              testItem.price !== undefined &&
              testItem.price !== null
            ) {
              sessionPrices.tests[testItem.id] = testItem.price;

              // For grouped measurements, also extract prices from total array
              if (
                testItem.total &&
                Array.isArray(testItem.total) &&
                testItem.total.length > 0
              ) {
                testItem.total.forEach((childItem) => {
                  const childId = childItem.id || childItem.testId;
                  const childPrice =
                    childItem.price !== undefined
                      ? childItem.price
                      : childItem.testPrice || 0;
                  if (
                    childId &&
                    childPrice !== undefined &&
                    childPrice !== null
                  ) {
                    sessionPrices.tests[childId] = childPrice;
                  }
                });
              }
            }
          });
        }

        setSessionBookedPrices(sessionPrices);

        // Have package
        if (!isEmpty(newLstPackages)) {
          const { id, name, price } = newLstPackages[0];
          let lstOptionalTests = [];
          packageDispatcher.getPackageById(id, (result) => {
            const {
              lstProfiles,
              lstTests: lstPackageTests,
              totalMandatoryProcedure,
              totalMandatoryRadiology,
            } = result;

            // Get list of Profile, Procedure, Radiology
            // Filter unmandatory test
            // Filter Optional test based on ingnored Test
            let lstProcedures = [];
            let lstRadiologies = [];
            let newListTest = [];
            let newTotalMandatoryProcedure = [];
            let newTotalMandatoryRadiology = [];

            if (isFollowUp && !isEmpty(doneFollowUpTests)) {
              newListTest = lstPackageTests.map((item) => {
                const holdDoneFollowUpTests = doneFollowUpTests.filter(
                  (it) => it.category === item.category && !it.isAddon
                );

                return {
                  ...item,
                  items: item.items.filter(
                    (test) =>
                      holdDoneFollowUpTests.findIndex(
                        (item) => item.testId === test.id
                      ) === -1
                  ),
                };
              });
            } else {
              newListTest = lstPackageTests;
            }
            let newLstTestProcedures = [];
            let newLstTestRadiologies = [];
            let holdDoneFollowUpTestsProcedures = [];
            let holdDoneFollowUpTestsRadiologies = [];

            lstPackageTests.forEach((item) => {
              if (item.category === 'Procedures') lstProcedures = item.items;
              if (item.category === 'Radiologies') lstRadiologies = item.items;
            });

            if (isFollowUp) {
              const unMandatoryProcedures = [...lstProcedures]?.filter(
                (it) => !it.isRequired
              );
              const unMandatoryRadiologies = [...lstRadiologies]?.filter(
                (it) => !it.isRequired
              );

              if (!isEmpty(doneFollowUpTests)) {
                // Procedure
                holdDoneFollowUpTestsProcedures = unMandatoryProcedures.filter(
                  (it) =>
                    doneFollowUpTests.find((item) => item.testId === it.id)
                );

                newLstTestProcedures = unMandatoryProcedures.map((item) => {
                  const itemDone = doneFollowUpTests?.find(
                    (it) => it.testId === item.id && !it.isAddon
                  );

                  let selectedProcedures = {};
                  if (isEmpty(ignoredTests)) {
                    selectedProcedures = ignoredTests?.some((test) => {
                      return item.id === test.testId;
                    });
                  } else {
                    selectedProcedures = ignoredTests?.every((test) => {
                      return item.id !== test.testId;
                    });
                  }

                  if (itemDone) {
                    return { ...item, isDone: true, isChecked: false };
                  } else if (selectedProcedures)
                    return { ...item, isDone: false, isChecked: true };

                  return { ...item, isDone: false, isChecked: false };
                });
                newLstTestProcedures = newLstTestProcedures.filter(
                  (test) =>
                    holdDoneFollowUpTestsProcedures.findIndex(
                      (item) => item.id === test.id
                    ) === -1
                );

                // Radiologies
                holdDoneFollowUpTestsRadiologies =
                  unMandatoryRadiologies.filter((it) =>
                    doneFollowUpTests.find((item) => item.testId === it.id)
                  );

                newLstTestRadiologies = unMandatoryRadiologies.map((item) => {
                  const itemDone = doneFollowUpTests?.find(
                    (it) => it.testId === item.id && !it.isAddon
                  );

                  let selectedRadiologies = {};
                  if (isEmpty(ignoredTests)) {
                    selectedRadiologies = ignoredTests?.some((test) => {
                      return item.id === test.testId;
                    });
                  } else {
                    selectedRadiologies = ignoredTests?.every((test) => {
                      return item.id !== test.testId;
                    });
                  }

                  if (itemDone) {
                    return { ...item, isDone: true, isChecked: false };
                  } else if (selectedRadiologies)
                    return { ...item, isDone: false, isChecked: true };

                  return { ...item, isDone: false, isChecked: false };
                });

                newLstTestRadiologies = newLstTestRadiologies.filter(
                  (test) =>
                    holdDoneFollowUpTestsRadiologies.findIndex(
                      (item) => item.id === test.id
                    ) === -1
                );
              } else {
                newLstTestProcedures = unMandatoryProcedures.map((item) => {
                  const itemChecked = lstProcedures.find(
                    (it) => it.id === item.id
                  );

                  if (itemChecked) {
                    return { ...item, isDone: false, isChecked: true };
                  }
                  return { ...item, isDone: false, isChecked: false };
                });

                newLstTestRadiologies = unMandatoryRadiologies.map((item) => {
                  const itemChecked = lstRadiologies.find(
                    (it) => it.id === item.id
                  );

                  if (itemChecked) {
                    return { ...item, isDone: false, isChecked: true };
                  }
                  return { ...item, isDone: false, isChecked: false };
                });
              }

              newTotalMandatoryProcedure =
                totalMandatoryProcedure -
                holdDoneFollowUpTestsProcedures.length;

              newTotalMandatoryRadiology =
                totalMandatoryRadiology -
                holdDoneFollowUpTestsRadiologies.length;
            } else {
              newTotalMandatoryProcedure = totalMandatoryProcedure;
              newTotalMandatoryRadiology = totalMandatoryRadiology;
            }

            lstOptionalTests = returnOptionalPackageTests({
              lstProcedures: newLstTestProcedures,
              lstRadiologies: newLstTestRadiologies,
              lstProfiles,
              ignoredTests: newIgnoredTests,
              ignoredProfiles: newIgnoredProfiles,
            });

            setLstOptionalTests(lstOptionalTests);
            if (isFollowUp) {
              setPackageDetail({
                ...result,
                lstTests: newListTest,
                lstProcedures: newLstTestProcedures,
                lstRadiologies: newLstTestRadiologies,
                totalMandatoryProcedure: newTotalMandatoryProcedure,
                totalMandatoryRadiology: newTotalMandatoryRadiology,
                name,
                price,
                holdDoneFollowUpTestsRadiologies,
                holdDoneFollowUpTestsProcedures,
                bypassRestrictedLocationIds:
                  result?.bypassRestrictedLocationIds || [],
              });
            } else {
              setPackageDetail({
                ...result,
                lstProcedures,
                lstRadiologies,
                name,
                price,
                bypassRestrictedLocationIds:
                  result?.bypassRestrictedLocationIds || [],
              });
            }

            setDataPackageExisted({
              ...result,
              ...newLstPackages[0],
              lstTests: newListTest,
              ignoredTests: newIgnoredTests,
              ignoredProfiles: newIgnoredProfiles,
              lstProfiles,
              lstProcedures,
              lstRadiologies,
              totalMandatoryProcedure: newTotalMandatoryProcedure,
              totalMandatoryRadiology: newTotalMandatoryRadiology,
              price,
            });
            setCurrentPackage({
              ...result,
              ...newLstPackages[0],
              lstTests: newListTest,
              ignoredTests: newIgnoredTests,
              ignoredProfiles: newIgnoredProfiles,
              lstProfiles,
              lstProcedures,
              lstRadiologies,
              totalMandatoryProcedure: newTotalMandatoryProcedure,
              totalMandatoryRadiology: newTotalMandatoryRadiology,
              price,
            });
          });
        }
        if (!isAfterRegistration) {
          const newLstTests = formatData({ lstTests: apptData.lstTests });

          setFormValue({
            ...newLstTests,
            lstScreeningFields: filterScreeningField,
            projectId: apptData.projectId,
            lstProfiles: apptData.lstProfiles,
            lstPackages: apptData.lstPackages,
            ignoredTests: apptData.ignoredTests,
            ignoredProfiles: apptData.ignoredProfiles,
            staffType,
            code: apptData.code,
          });
        } else {
          let newLstTests = formatMeasurementInSideListTest(lstTests);
          newLstTests = formatData({ lstTests: newLstTests });

          setFormValue({
            ...newLstTests,
            lstScreeningFields: filterScreeningField,
            projectId: apptData.projectId,
            lstProfiles,
            lstPackages,
            ignoredTests,
            ignoredProfiles,
            staffType,
            code: apptData.code,
          });
        }
        setLoading(false);
      });

      companyDispatcher.getProjectByID(apptData.projectId, (result) => {
        setProjectInfo(result);
        setProjectCustomFields({
          id: result.id,
          name: result.name,
          items: result.lstProjectCustomFields,
        });
      });
      // Hadndle restricted test ids
      locationDispatcher.getDetailLocation(apptData.locationId, (result) => {
        const { restrictedTestIds } = result;
        setRestrictedTestIds(restrictedTestIds);
      });
    }
  }, [apptData, isAfterRegistration, isFollowUp]);
  useEffect(() => {
    if (isEmpty(packageDetail)) return;
    if (isFollowUp) {
      const { lstRadiologies, lstProcedures } = packageDetail;
      const { ignoredTests } = formValue;
      // let newLstRadiologies = cloneDeep(lstRadiologies);
      // let newLstProcedures = cloneDeep(lstProcedures);

      // Filter test restricted by location
      // if (!isEmpty(restrictedTestIds)) {
      //   newLstProcedures = newLstProcedures?.filter(
      //     it => !restrictedTestIds?.includes(it.id)
      //   );
      //   newLstRadiologies = newLstRadiologies?.filter(
      //     it => !restrictedTestIds?.includes(it.id)
      //   );
      // }
      // Get list of Profile, Procedure, Radiology
      // Filter unmandatory test
      // Filter Optional test based on ingnored Test
      let lstOptionalTests = [];
      lstOptionalTests = returnOptionalPackageTests({
        lstProcedures,
        lstRadiologies,
        ignoredTests,
      });

      setLstOptionalTests(lstOptionalTests);
    } else {
      if (isEmpty(currentPackage)) {
        const { lstRadiologies, lstProcedures, lstProfiles } = packageDetail;
        const { ignoredProfiles, ignoredTests } = formValue;
        // let newLstRadiologies = [];
        // let newLstProcedures = [];

        // Filter test restricted by location
        // if (!isEmpty(restrictedTestIds)) {
        //   newLstProcedures = lstProcedures?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        //   newLstRadiologies = lstRadiologies?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        // }

        // Get list of Profile, Procedure, Radiology
        // Filter unmandatory test
        // Filter Optional test based on ingnored Test
        let lstOptionalTests = [];
        lstOptionalTests = returnOptionalPackageTests({
          lstRadiologies,
          lstProcedures,
          lstProfiles,
          ignoredTests,
          ignoredProfiles,
        });
        setLstOptionalTests(lstOptionalTests);
      } else {
        let {
          lstRadiologies,
          lstProcedures,
          lstProfiles,
          ignoredProfiles,
          ignoredTests,
        } = currentPackage;

        // Filter test restricted by location
        // if (!isEmpty(restrictedTestIds)) {
        //   newLstProcedures = newLstProcedures?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        //   newLstRadiologies = newLstRadiologies?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        // }

        // Get list of Profile, Procedure, Radiology
        // Filter unmandatory test
        // Filter Optional test based on ingnored Test
        let lstOptionalTests = [];
        lstOptionalTests = returnOptionalPackageTests({
          lstRadiologies,
          lstProcedures,
          lstProfiles,
          ignoredTests,
          ignoredProfiles,
        });
        setLstOptionalTests(lstOptionalTests);
      }
    }
  }, [isFollowUp, formValue, packageDetail, currentPackage, restrictedTestIds]);

  if (!apptData || isEmpty(apptData)) {
    history.push(`/${urlLabel.allScreenings}`);
  }

  const isEmptyFilterParams = useMemo(() => {
    const filterKeys = [
      'lstPackages',
      'lstProfiles',
      'lstMeasurements',
      'lstProcedures',
      'lstRadiologies',
      'lstVaccinations',
      'lstReviews',
      'lstTests',
    ];

    // Check package required optional but don't select any test
    // Check don't select any test

    if (!isEmpty(formValue.lstPackages) && !isEmpty(packageDetail)) {
      const {
        lstProcedures,
        lstRadiologies,
        lstProfiles,
        totalMandatoryProcedure,
        totalMandatoryProfile,
        totalMandatoryRadiology,
        holdDoneFollowUpTestsRadiologies,
        holdDoneFollowUpTestsProcedures,
      } = packageDetail;
      const { ignoredTests, ignoredProfiles } = formValue;
      const isBypassRestrictedLocation = Array.isArray(
        packageDetail?.bypassRestrictedLocationIds
      )
        ? packageDetail.bypassRestrictedLocationIds.includes(locationId)
        : false;
      let newProcedures = isBypassRestrictedLocation
        ? lstProcedures
        : lstProcedures?.filter((it) => !restrictedTestIds?.includes(it.id));
      let newRadiologies = isBypassRestrictedLocation
        ? lstRadiologies
        : lstRadiologies?.filter((it) => !restrictedTestIds?.includes(it.id));
      // Profiles
      const unMandatoryProfiles = cloneDeep(lstProfiles)?.filter(
        (it) => !it.isRequired
      );
      const selectedProfiles = unMandatoryProfiles?.filter((value) => {
        return ignoredProfiles?.some((test) => {
          return value.id === test.profileId;
        });
      });
      // Procedures
      const unMandatoryProcedures = cloneDeep(newProcedures)?.filter(
        (it) => !it.isRequired
      );
      const selectedProcedures = unMandatoryProcedures?.filter((value) => {
        return ignoredTests?.some((test) => {
          return value.id === test.testId;
        });
      });
      const selectedRequiredProcedures = unMandatoryProcedures?.filter(
        (value) => {
          return ignoredTests?.every((test) => {
            return value.id !== test.testId;
          });
        }
      );

      // Radiology
      const unMandatoryRadiology = cloneDeep(newRadiologies)?.filter(
        (it) => !it.isRequired
      );
      const selectedRadiology = unMandatoryRadiology?.filter((value) => {
        return ignoredTests?.some((test) => {
          return value.id === test.testId;
        });
      });

      const selectedRequiredRadiology = unMandatoryRadiology?.filter(
        (value) => {
          return ignoredTests?.every((test) => {
            return value.id !== test.testId;
          });
        }
      );

      if (isFollowUp) {
        /*
          totalMandatoryProcedure : Total Procedure must be selected
          holdDoneFollowUpTestsProcedures : Procedure (optional) had already done
          selectedRequiredProcedures: Other Procedure (optional) that can be selected
        */

        const checkFollowProcedures = !(totalMandatoryProcedure -
          holdDoneFollowUpTestsProcedures.length ===
        0
          ? totalMandatoryProcedure === selectedRequiredProcedures.length
          : totalMandatoryProcedure - holdDoneFollowUpTestsProcedures.length ===
            selectedRequiredProcedures.length);

        const checkFollowRadiology = !(totalMandatoryRadiology -
          holdDoneFollowUpTestsRadiologies.length ===
        0
          ? totalMandatoryRadiology === selectedRequiredRadiology.length
          : totalMandatoryRadiology -
              holdDoneFollowUpTestsRadiologies.length ===
            selectedRequiredRadiology.length);

        return checkFollowProcedures || checkFollowRadiology;
      } else
        return (
          unMandatoryProfiles?.length - selectedProfiles?.length !==
            totalMandatoryProfile ||
          unMandatoryProcedures?.length - selectedProcedures?.length !==
            totalMandatoryProcedure ||
          unMandatoryRadiology?.length - selectedRadiology?.length !==
            totalMandatoryRadiology
        );
    }

    return !filterKeys.some((key) =>
      isBoolean(formValue[key]) ? formValue[key] : !isEmpty(formValue[key])
    );
  }, [formValue, isFollowUp, packageDetail, restrictedTestIds, locationId]);

  return (
    <>
      <CustomPaperContainer
        header={
          <CustomHeader
            title="Edit package"
            isSearch={false}
            renderButton={() => (
              <Button color="primary" variant="outlined" onClick={onCancel}>
                Cancel
              </Button>
            )}
          />
        }
        children={
          <>
            <Paper square variant="outlined" className={classes.container}>
              <Box flexDirection="column" className={classes.leftContainer}>
                {!loading &&
                  (isFollowUp ? (
                    <FollowSelectServices
                      formValue={formValue}
                      setFormValue={setFormValue}
                      projectId={apptData.projectId}
                      packageDetail={packageDetail}
                      dataExist={apptData}
                      restrictedTestIds={restrictedTestIds}
                    />
                  ) : (
                    <SelectServices
                      formValue={formValue}
                      setFormValue={setFormValue}
                      projectId={apptData.projectId}
                      locationId={locationId}
                      handleChangeData={handleChangeData}
                      packageDetail={packageDetail}
                      setPackageDetail={setPackageDetail}
                      projectCustomFields={projectCustomFields}
                      setCurrentPackage={setCurrentPackage}
                      currentPackage={currentPackage}
                      dataPackageExisted={dataPackageExisted}
                      restrictedTestIds={restrictedTestIds}
                      sessionBookedPrices={sessionBookedPrices}
                    />
                  ))}
              </Box>
              <Box
                flexDirection="column"
                gridGap={16}
                className={classes.rightContainer}
              >
                <Invoice
                  apptData={apptData}
                  lstTests={generateLstTests(formValue)}
                  lstProfiles={formValue?.lstProfiles}
                  lstPackages={formValue?.lstPackages}
                  ignoredProfiles={formValue?.ignoredProfiles}
                  ignoredTests={formValue?.ignoredTests}
                  lstOptionalTests={lstOptionalTests}
                  projectInfo={projectInfo}
                  staffType={apptData?.staffType}
                  subsidy={apptData?.subsidy}
                  billableAmount={
                    hasEditPackage ? null : apptData?.billableAmount
                  }
                  originalPrices={originalPrices}
                  originalLstTestsForPreCalculate={
                    originalLstTestsForPreCalculate
                  }
                  isFollowUp={isFollowUp}
                />
                {!isFollowUp && projectInfo?.name === CHS_PROJECT_NAME && (
                  <Box>
                    <CustomTitleSubLabel>Code</CustomTitleSubLabel>
                    <CustomTextField
                      fullWidth
                      variant="outlined"
                      placeholder="Enter code"
                      value={formValue?.code || ''}
                      onChange={(e) =>
                        setFormValue({ ...formValue, code: e.target.value })
                      }
                      InputProps={{
                        endAdornment: (
                          <ClearComponent
                            id="code"
                            value={formValue.code}
                            onClear={() =>
                              setFormValue({ ...formValue, code: '' })
                            }
                          />
                        ),
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Paper>
            <Toolbar>
              <Box
                width="100%"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                py={2}
              >
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    if (
                      !isFollowUp &&
                      isHomebasedAvailable(formValue.lstPackages?.[0])
                    ) {
                      return setOpenHomebasedConfirm(true);
                    }
                    onSubmit();
                  }}
                  disabled={isEmptyFilterParams}
                >
                  Save changes
                </Button>
              </Box>
            </Toolbar>
          </>
        }
      />
      <ModalConfirmation
        open={openHomebasedConfirm}
        maxWidth="md"
        style={{ paddingLeft: 24, paddingRight: 24 }}
        Icon={<HomebasedIcon />}
        mainContent="Start Your Screening from Home"
        subContent={
          <>
            Your package includes home-based blood taking at{' '}
            <b>no additional cost</b>. A Minmed nurse can visit your home or
            office, so you can fit it around your day and spend less time at the
            screening centre.
          </>
        }
        subContent2={
          <>
            <b>$30 Grab transport</b> is covered for your trip to the screening
            centre for your remaining tests. Would you like to arrange it?
          </>
        }
        subContent2Style={{ color: '#666666' }}
        cancelLabel="No"
        confirmLabel="Yes"
        onCancel={() => {
          // Declining homebased: proceed with the normal EHS appointment.
          setHomebasedInfo(null);
          setOpenHomebasedConfirm(false);
          onSubmit(null);
        }}
        onClick={() => {
          setOpenHomebasedConfirm(false);
          setOpenHomebasedModal(true);
        }}
      />
      <HomebasedBloodTakingModal
        open={openHomebasedModal}
        patientId={patientId}
        onClose={() => setOpenHomebasedModal(false)}
        onConfirm={(data) => {
          setHomebasedInfo(data);
          setOpenHomebasedModal(false);
          onSubmit(data);
        }}
      />
    </>
  );
};

export default EditPackage;
